module.exports = __webpack_public_path__ + "img/index-ship02.1cce6e40.png";